import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../components/FormikControl/FormikControl';

import useCordinates from '../../hooks/useCordinates';
import { useAlert } from '../../context/AlertContext';

import ComplaintImageCapture from './complaint/ComplaintImageCapture';
import { CircularProgress } from '@mui/material';
import CaptchaInput from '../../components/AppInput/CaptchaInput';
import useSystemMasterList from '../../hooks/useSystemMasterList';
import portalServices from '../portalServices';


function ComplaintFormComponent() {

    let { grievanceType } = useParams();
    const navigate = useNavigate();
    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
    const {AppAlert} = useAlert();
    const cordinates = useCordinates();
    //const [geolocationStatus,setGeoLocationStatus] = useState(false);

    const [imageFile,setImageFile] = useState(null);
    const [captchaData,setCaptchaData] = useState(null);
    const [saving,setSavingStatus] = useState(false);

    const initialValues = {
        complainantName	:'',
        //phone:'',
        details:'',
        grievanceType:grievanceType? parseInt(grievanceType):"",
        wardNo:'',
        address:'',
        addressHelper:'',
    }

    const validationRule = Yup.object({
        complainantName	: Yup.string().required("Required"),
        //phone:Yup.string().required("Required").matches(/^[0-9]+$/, "Invalid Phone Number").min(10, 'Invalid Phone Number').max(10, 'Invalid Phone Number'),
        details: Yup.string().required("Required"),
        grievanceType: Yup.string().required("Required"),
    });


    const handleImageInput = (file) =>{
        setImageFile(file)
    }

    const onSubmit = (payload) =>{

        if(getMasterLabel("grievance-type",payload.grievanceType) === ""){
            AppAlert("Invalid Complaint Type","error");
            return false;
        }

        let values ={...payload};

        if(imageFile !== null){
            values.imageFile = imageFile;
        }

        //values.phone = "91"+values.phone
        values.customerPhone = localStorage.customerPhone;
        values.latitude = cordinates.latitude;
        values.longitude = cordinates.longitude;
        values.captchaData=captchaData;

        setSavingStatus(true);
        portalServices.submitComplaint(values).then(res=>{
            //console.log(res)

            if(res.error){
                AppAlert("Invalid Captcha","error")
            } else {
                AppAlert("Your Complaint Registered Successfully")
                //sessionStorage.setItem("customerPhone",values.phone)
                navigate("/complaint/list")
                //window.location.reload();
            }  
        }).catch(error=>{
            console.log(error)
            AppAlert("Someting Went wrong! Try Again","error")
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    useEffect(()=>{
        console.log("grievance Type is",grievanceType)
    },[])

    return (
        <>
            
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => 
                            <Form>
                                <div className='card'>
                                    <div className='card-body'>
                                        {grievanceType!==undefined &&
                                        <div className='row'>
                                            <div className='col-md-12 text-center'>
                                                <h4 className='bg-info rounded p-3'>Reporting : <span className='fw-bold' >{getMasterLabel("grievance-type",parseInt(grievanceType)) } </span></h4>
                                            </div>
                                        </div>
                                        }
                                        <div className='row'>
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Your Name" name="complainantName" 
                                                />
                                            </div>
                                        
                                            <div className='col-md-6 mb-3 border rounded p-2 bg-light'>
                                                {/*
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Phone No." name="phone" 
                                                />
                                                */}
                                                {localStorage.guestPhone}
                                            </div>
                                            
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <h5>Complaint Details</h5>
                                            </div>
                                            {grievanceType === undefined &&
                                            <div className='col-md-12 mb-3'>
                                                {masters && 
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Complaint About" name="grievanceType"  
                                                        options={masters['grievance-type']} multiple={false} 
                                                    />
                                                }
                                            </div>
                                            }
                                            

                                            <div className='col-md-12 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Your Complaint" name="details" 
                                                    multiline rows={4}
                                                />
                                            </div>

                                            <div className='col-md-12 mb-3'>
                                                <h6>Complaint Photo</h6>
                                                <ComplaintImageCapture callback={handleImageInput} />
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Ward No" name="wardNo" 
                                                />
                                            </div>

                                            <div className="col-md-12">
                                                <h5>Complaint Address</h5>
                                                <div className='col-md-12 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Address" name="address" 
                                                    multiline rows={2}
                                                />
                                            </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        {saving && 
                                            <div className='text-center'>
                                                Submiting your complaint please wait... 
                                                <span className=''><CircularProgress/></span>
                                            </div>
                                        }
                                        {!saving && 
                                            <div className='row'>
                                                <div className='col-md-6 my-2'>
                                                    <CaptchaInput callBack={setCaptchaData} /> 
                                                </div>
                                                <div className='col-md-6 my-2'>
                                                        {!cordinates && 
                                                            <span className='text-danger'>Please Allow Location Access to Continue</span>
                                                        }
                                                    <button   disabled={!formik.isValid || !cordinates || !captchaData}  className='btn btn-lg btn-success float-end' type='submit' > Book My Complaint </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {/*JSON.stringify(formik.values) */}
                            </Form>
                    }
                </Formik>
            
        </>
    )
}

export default ComplaintFormComponent